import { ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { uniq } from 'lodash';

const importKeyColumn = 'Company name';

const CATEGORIES = {
    'Trainee positons': '2f61d8d6-4543-4a3b-a505-f95efdd0faad',
    'Full-time employment': 'bca36f93-a20f-40c7-9f1c-35cfbef88f83',
    'Part-time employment': 'd012dae5-dbf5-4adb-ac62-241399ba246b',
    Thesis: 'f95aba02-585e-41fe-901e-536546d3076e',
    Internships: '3ac9a5c6-da66-4690-8238-bc0916417c41',
    Graduate: '4ad4dcf9-d9f3-495c-a438-52562faf69ea'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    function getLogo() {
        const str = row['Image']?.trim();

        if (!str) {
            return undefined;
        }

        const imageId = str
            .replace('https://drive.google.com/open?id=', '')
            .replace('&usp=drive_copy', '')
            .trim();
        const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

        return imageUrl;
    }

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKeyColumn],
            header: {
                title: row['Company name'],
                text: row['Short description about the company'],
                imageUrl: getLogo()
            }
        },
        cards: []
    };

    if (row['Link to website']) {
        mutationPayload.cards.push({
            type: ECardType.LINK,
            links: [
                {
                    title: 'Website',
                    url: row['Link to website']
                }
            ]
        });
    }

    if (row['What are you looking for in students?']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'What are you looking for in students?',
                description: row['What are you looking for in students?']
            }
        });
    }

    if (row['Industry/Field (ex. Banking, consulting, etc)']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Industry/Field',
                description: row['Industry/Field (ex. Banking, consulting, etc)']
                    ?.split(',')
                    .map((e) => e.trim())
                    .join('\n')
            }
        });
    }

    console.log(row);

    if (row['What do you offer students?']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'What do you offer students?',
                description: row['What do you offer students?']
                    .split(';')
                    .map((e) => e.trim())
                    .filter(Boolean)
                    .join('\n')
            }
        });
    }

    if (row['Openings for international students?']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Openings for international students?',
                description: row['Openings for international students?']
            }
        });
    }

    if (
        row[
            'Students for which programs should seek you out? (Select all programs you are interested in students from)'
        ]
    ) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Students for which programs should seek you out',
                description: row[
                    'Students for which programs should seek you out? (Select all programs you are interested in students from)'
                ]
                    .split(';')
                    .map((e) => e.trim())
                    .filter(Boolean)
                    .join('\n')
            }
        });
    }

    const categories = row['What do you offer students?']
        .split(';')
        .map((e) => e.trim())
        .map((e) => CATEGORIES[e])
        .filter(Boolean);
    mutationPayload.addToCategoriesId = uniq(categories);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKeyColumn]?.toLowerCase();
}

export const biso2024ImportMethods = { duplicateChecker, parser, importKeyColumn };
